import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import CatMascot from '../assets/under_development_images/cat.png';
import OwlMascot from '../assets/under_development_images/owl.png';

function UnderDevelopment() {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        if (prev.length >= 3) return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50 overflow-hidden">
      {/* Decorative background blobs */}
      <div className="absolute top-10 left-10 w-72 h-72 md:w-96 md:h-96 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-72 h-72 md:w-96 md:h-96 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse delay-1000"></div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 pt-28 pb-20">
        <div className="max-w-3xl mx-auto text-center">

          {/* Jumping mascots */}
          <div className="mb-10 flex items-end justify-center gap-6 sm:gap-10">
            <img
              src={CatMascot}
              alt="WealthyCats mascot"
              className="h-32 sm:h-40 md:h-48 w-auto animate-bounce [animation-duration:1.6s] drop-shadow-lg"
            />
            <img
              src={OwlMascot}
              alt="Wealthy Owl mascot"
              className="h-28 sm:h-36 md:h-44 w-auto animate-bounce [animation-duration:1.6s] [animation-delay:0.8s] drop-shadow-lg"
            />
          </div>

          {/* Eyebrow */}
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#F4900C]">
              <span className="h-px w-8 bg-[#F4900C]/40"></span>
              Coming Soon
              <span className="h-px w-8 bg-[#F4900C]/40"></span>
            </span>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Under{' '}
            <span className="bg-gradient-to-r from-[#FED700] to-[#F4900C] bg-clip-text text-transparent">
              Development
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-gray-700 font-medium mb-10">
            Something amazing is coming soon
            <span className="text-[#F4900C]">{dots}</span>
          </p>

          {/* Call to action */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/home"
              className="px-8 py-4 bg-gradient-to-r from-[#FED700] to-[#F4900C] hover:from-[#FED700]/90 hover:to-[#F4900C]/90 text-gray-900 font-bold rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300 text-lg"
            >
              Return to Homepage
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 bg-white border-2 border-[#F4900C] text-[#F4900C] hover:bg-[#F4900C] hover:text-white font-semibold rounded-lg transition-all duration-300 text-lg"
            >
              Contact Us
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}

export default UnderDevelopment;
